import React, { FC } from "react";

import { FavouriteProvider } from "../../../../bulkexport/providers/FavouriteProvider";

import { BulkExportProvider } from "../../../../bulkexport/providers";
import { FavouritesSettingsBulkExport } from "./FavouritesSettingsBulkExport";
import { IFavouritesSettingsBulkExportProps } from "./FavouritesSettingsBulkExport.types";
export const FavouritesSettingsBulkExportProvider: FC<IFavouritesSettingsBulkExportProps> = ({ item }) => {
  return (
    <BulkExportProvider>
      <FavouriteProvider>
        <FavouritesSettingsBulkExport item={item} />
      </FavouriteProvider>
    </BulkExportProvider>
  );
};
